// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__pqjgR","info":"PatientInfo_info__2zBqT"};